export const taskReviewForCraneTeamLead = {
	pcu: { id: 'pcu', name: 'PCU', CR: true, taskReview: true },
	crane: { id: 'crane', name: 'Crane', CR: true, taskReview: true },
  };
  export const sitePlanForCraneAndPcu = {
	pcu: { id: 'pcu', name: 'PCU', CR: true, sitePlan: true },
	crane: { id: 'crane', name: 'Crane', CR: true, sitePlan: true },
  };
  